export default function getHeaderProps(column, hasSortBy, id) {
  const defaultProps = column.getHeaderProps(
    (hasSortBy &&
      !column.disableSort &&
      column.getSortByToggleProps([
        {
          ...(column.header && column.header),
          align: column.align,
          minWidth: column.minWidth,
          width: column.width,
          maxWidth: column.maxWidth,
          paddingLeft: column.paddingLeft,
          style: {
            color: column.header && column.header.color,
            ...(column.header && column.header.style && column.header.style),
          },
        },
      ])) || [
      {
        ...(column.header && column.header),
        align: column.align,
        minWidth: column.minWidth,
        width: column.width,
        maxWidth: column.maxWidth,
        paddingLeft: column.paddingLeft,
        style: {
          color: column.header && column.header.color,
          ...(column.header && column.header.style && column.header.style),
        },
      },
    ]
  )

  return {
    id: `${id ? id + '-' : ''}th-${column.id}`,
    ...defaultProps,
  }
}
